
import React, { useState } from 'react';

import '../styles/Experience.css';
import '../styles/Projects.css';

const experiences = [
  {
    id: 1,
    company: "Visual Tech Institute",
    role: "Web Developer",
    points: [
      "Dynamic Migration: Converted static sites Inwent.ca into fully functional dynamic platforms with custom responsive styling.",
      "Full-Stack Enhancements: Developed key functionalities and optimized UI/UX for the Visual Tech official website.",
      "Deployment & DevOps: Managed live deployments and site migrations on Hostinger, including full backup management for multiple client projects."
    ]
  },
  {
    id: 2,
    company: "Ronix Software",
    role: "Web Developer",
    points: [
      "Portfolio Development: Built and optimized the company’s Ronix Software Portfolio using high-quality frontend technologies.",
      "Frontend Specialization: Delivered multiple client-side projects, focusing on pixel-perfect UI/UX and clean, modular code.",
      "JS Stack Implementation: Developed custom web solutions by effectively utilizing JavaScript libraries and modern web standards."
    ]
  },
  {
    id: 3,
    company: "Code Alpha",
    role: "Full Stack Developer",
    points: [
      "Social Media App: Developed a feature-rich social media application with real-time user interaction using the MERN stack.",
      "E-commerce Platform: Engineered a complete e-commerce solution with product management, cart functionality, and secure checkout.",
      "Backend Optimization: Improved server response times by 20% through optimized MongoDB queries and efficient API endpoint handling."
    ]
  }
];

const Experience = () => {
  const [selected, setSelected] = useState(experiences[0]); // default first company

  return (
    <section className="experience-section" id="experience">
        <div className="projects-header">
                    <h2 className="section-title">My <span className="highlight">Experience</span></h2>
                    <p className="section-subtitle">Here's an overview of my professional journey in web development.</p>
                </div>
      <div className="container experience-container">
        <div className="experience-left">
          {experiences.map(exp => (
            <div
              key={exp.id}
              className={`company-name ${selected.id === exp.id ? 'active' : ''}`}
              onClick={() => setSelected(exp)}
            >
              {exp.company}
            </div>
          ))}
        </div>
        <div className="experience-right">
          <h3 className="role">{selected.role} | <span className="company">{selected.company}</span></h3>
          <ul className="experience-points">
            {selected.points.map((point, i) => (
              <li key={i} className="point">• {point}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Experience;